import { render, staticRenderFns } from "./DatePickerTailwind.vue?vue&type=template&id=bdae703a&scoped=true&"
import script from "./DatePickerTailwind.vue?vue&type=script&lang=js&"
export * from "./DatePickerTailwind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdae703a",
  null
  
)

export default component.exports